export const Invoicing = {
    toServer: (invoice) => {
        return {
            business_id: invoice.name,
            vat: invoice.vat,
            code: invoice.adeCode,
            address: invoice.address,
            zipcode: invoice.zip,
            province: invoice.province,
            pec: invoice.pec,
            city: invoice.city
        }
    },
    fromServer: (invoicing) => {
        return {
            name: invoicing.business_id,
            vat: invoicing.vat,
            adeCode: invoicing.code,
            address: invoicing.address,
            zip: invoicing.zipcode,
            province: invoicing.province,
            pec: invoicing.pec,
            city: invoicing.city
        }
    }
}